import * as React from 'react';
import { 
  Bar, 
  BarChart, 
  CartesianGrid, 
  Legend, 
  ResponsiveContainer, 
  Tooltip, 
  XAxis, 
  YAxis 
} from 'recharts';
import './Styles.css'

export default function BarChart1(props) {
  const data = props.seriesData;
  const layout = props.layout ?? 'horizontal'
  const height = props.height ?? 250; // Default height for better visibility
  
  const axisLayout = () => {
    if (layout === 'vertical') {
      return (
        <>
          <XAxis 
            type='number' 
            tick={{ fontSize: 12 }}
            axisLine={{ stroke: '#e2e8f0' }}
            tickLine={{ stroke: '#e2e8f0' }}
          />
          <YAxis 
            type='category' 
            dataKey="name" 
            tick={{ fontSize: 12 }}
            axisLine={{ stroke: '#e2e8f0' }}
            tickLine={{ stroke: '#e2e8f0' }}
          />
        </>
      )
    } else {
      return (
        <>
          <XAxis 
            type='category' 
            dataKey="name" 
            tick={{ fontSize: 12 }}
            axisLine={{ stroke: '#e2e8f0' }}
            tickLine={{ stroke: '#e2e8f0' }}
          />
          <YAxis 
            type='number' 
            tick={{ fontSize: 12 }}
            axisLine={{ stroke: '#e2e8f0' }}
            tickLine={{ stroke: '#e2e8f0' }}
          />
        </>
      )
    }
  }

  return (
    <div style={{ width: '100%', height: height, minHeight: 200 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout={layout}
          data={data}
          margin={{ top: 20, right: 20, left: 10, bottom: 20 }}
          className='barchart-custom'
        >
          <CartesianGrid 
            strokeDasharray="3 3" 
            stroke="#f1f5f9"
            opacity={0.7}
          />
          {axisLayout()}
          <Tooltip 
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Bar 
            dataKey="value" 
            fill="#3b82f6"
            radius={[4, 4, 0, 0]}
            stroke="#2563eb"
            strokeWidth={1}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
